import type { Category } from '../categories/category'
import type { City } from '../cities/city'

export class Business {
    businessId: string
    name: string
    googleRate?: number
    googleReviews?: number
    googleUrl?: string
    googleImage?: string
    googlePhone?: string
    googlePhoneIsWA?: boolean
    googlePhoneIsWAB?: boolean
    googleAddress?: string
    googleComplement?: string
    googleNumber?: string
    googleCEP?: string
    googleSite?: string
    googleYear?: string
    siteInstagram?: string
    siteEmail?: string
    sitePhone1?: string
    sitePhone2?: string
    sitePhone1IsWA?: boolean
    sitePhone2IsWA?: boolean
    sitePhone1IsWAB?: boolean
    sitePhone2IsWAB?: boolean
    createdAt: string | Date
    updatedAt: string | Date
    status: number
    districtId: string
    cityId: string
    categoryId: string
    cnpj?: string
    govEmail?: string
    govPhone?: string
    govSocio1?: string
    govSocio2?: string
    govSocio3?: string
    govDate?: Date
    categories: { category: Category }[]
    city: City
}
